import { Component } from '@angular/core'
import { OrderHistoryComponent } from '@monorepo-channels/components/feature-porto-bank'

@Component({
	standalone: true,
	selector: 'porto-bank-order-history-page',
	imports: [OrderHistoryComponent],
	template: '<feature-porto-bank-order-history/>',
})
export class OrdersHistoryPageComponent {}
